import { Theme } from '../types/theme.types';

export function componentStylesByTheme<T>(theme: Theme, sag: T, shs: T): T {
  return theme === 'shs' ? shs : sag;
}
